import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-e-company-info-isp',
    templateUrl: './e-company-info-isp.component.html',
    styleUrls: ['./e-company-info-isp.component.scss'],
    standalone: false
})
export class ECompanyInfoISPComponent {
     companyInfo!:FormGroup;
     isLoading = true;

     constructor(public generalService:GeneralService, public enrollmentService:EnrollmentService){
     }

     wizardObj: IWizard = {
          steps: [
               {step:1, text:'Welcome'} as WizardSteps,
               {step:2, text:'Company Information'} as WizardSteps,
               {step:3, text:'User Accounts'} as WizardSteps,
               {step:4, text:'Review'} as WizardSteps,
               {step:5, text:'Contract Documents'} as WizardSteps,
               {step:6, text:'Submit'} as WizardSteps,
               {step:7, text:'Billing Information'} as WizardSteps
          ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit(): void {
          
          this.companyInfo = new FormGroup({
               ispEstimatedCustomers: new FormControl(this.enrollmentService.newCustomer!.ispEstimatedCustomers, [
                    Validators.required,
                    Validators.max(999999999),
                    Validators.min(1),
                    Validators.pattern(/^([0-9]*)$/) 
               ]),
               ispAnnualScreenings: new FormControl(this.enrollmentService.newCustomer!.ispAnnualScreenings, [
                    Validators.required,
                    Validators.max(999999999),
                    Validators.min(1),
                    Validators.pattern(/^([0-9]*)$/) 
               ])
          });  
          
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = false;
     }
     
     get ispEstimatedCustomers() { return this.companyInfo!.get('ispEstimatedCustomers'); }
     get ispAnnualScreenings() { return this.companyInfo!.get('ispAnnualScreenings'); };  

     ngAfterViewInit(){
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy(){
          this.enrollmentService.newCustomer!.ispEstimatedCustomers = this.companyInfo!.get('ispEstimatedCustomers')?.value;
          this.enrollmentService.newCustomer!.ispAnnualScreenings = this.companyInfo!.get('ispAnnualScreenings')?.value;
          this.enrollmentService.saveToLocal();
     }

}
